import { Validators } from "@angular/forms";
import { FALLBACK_SETTLEMENT_METHOD } from "src/app/product-capture/model/consts/fallback-settlement.const";
import { ALL_SETTLEMENT_METHODS } from "src/app/product-capture/model/consts/settlement-method.const";
import { VALUATION_OBLIGATION_CHARACTERISTICS } from "src/app/product-capture/model/consts/valuation-obligation-characteristics";
import { DcSelectOptions, TableCols } from "../interfaces/static-data";
import { OBLIGATION_CHARACTERISTICS_ITEMS } from "./reference-entity";
import { createInputField, createSelectField, createToggleField, mapToDropdownItem } from "./static-data.utils";

const categories = mapToDropdownItem([
    'PAYMENT',
    'BORROWED_MONEY',
    'BOND',
    'LOAN',
    'BOND_OR_LOAN',
]);

const COMMA_SEPARATED_OPTIONS: DcSelectOptions = {
    isCommaSeparated: true,
    convertToArray: true,
    checkbox: true,
    multiple: true,
    searchable: true
};

export const PHYSICAL_SETTLEMENT_MATRIX_COLUMNS: TableCols[] = [
    createInputField({ key: 'transactionType', validators: [ Validators.required ] }),
    createSelectField({ key: 'obligationCategory'}, categories, { searchable: true }),
    createSelectField(
    { key: 'obligationCharacteristics' },
        OBLIGATION_CHARACTERISTICS_ITEMS,
        COMMA_SEPARATED_OPTIONS
    ),
    createSelectField({ key: 'valuationObligationCategory' }, categories, { searchable: true }),
    createSelectField(
    { key: 'valuationObligationCharacteristics' },
        [
            ...VALUATION_OBLIGATION_CHARACTERISTICS
         ], COMMA_SEPARATED_OPTIONS),
    createToggleField({ key: 'allGuarantees' }),
    createToggleField({ key: 'escrow' }),
    createToggleField({ key: 'noticeOfPubliclyAvailableInformation', displayValue: 'Notice of Publicly Available Info.' }),
    createSelectField({ key: 'creditEvents' },
        [
            'BANKRUPTCY',
            'FAILURE_TO_PAY',
            'GRACE_PERIOD_EXTENSION',
            'GOVERNMENTAL_INTERVENTION',
            'OBLIGATION_DEFAULT',
            'OBLIGATION_ACCELERATION',
            'REPUDIATION_MORATORIUM',
            'RESTRUCTURING',
            'MOD_R',
            'MOD_MOD_R',
            'PROVISIONS_RELATING_TO_MULTIPLE_HOLDER_OBLIGATIONS',
        ],
        COMMA_SEPARATED_OPTIONS
    ),
    createSelectField({ key: 'settlementMethod' }, ALL_SETTLEMENT_METHODS),
    createSelectField({ key: 'fallbackSettlementMethod' }, FALLBACK_SETTLEMENT_METHOD),
    createToggleField({ key: 'financialReferenceEntityTerms', displayValue: 'Financial Reference Entity Terms' }),
    createToggleField({ key: 'subordinatedEuropeanInsuranceTerms', displayValue: 'Subord. European Insurance Terms' }),
    createToggleField({ key: 'provisionsMonolineInsurer', displayValue: 'Monoline Supplement' }),
    createToggleField({ key: 'provisionsForRussianFederation', displayValue: 'Russian Federation' }),
    createToggleField({ key: 'addnProvisionsCertainRussianEntities', displayValue: 'Certain Russian Entities' }),
    createToggleField({ key: 'provisionsForRepublicOfHungary', displayValue: 'Republic of Hungary' }),
    createToggleField({ key: 'addnProvisionsCertainVenezuelanEntities', displayValue: 'Certain Venezuelan Entities' }),
    createToggleField({ key: 'provisionsForArgentineRepublic', displayValue: 'Argentine Republic' }),
    createToggleField({ key: 'provisionsForLPN', displayValue: 'LPN' }),
    createToggleField({ key: 'provisionsForSukukCorporate', displayValue: 'Sukuk' }),
    createToggleField({ key: 'addnProvisionsHellenicRepublic', displayValue: 'Hellenic Republic' }),
    createToggleField({ key: 'supplementTo2014ISDACDD', displayValue: 'CoCo Supplement' }),
    createToggleField({ key: 'ntceSupplement', displayValue: 'NTCE Supplement' }),
    createToggleField({ key: 'suppUSMunicipals', displayValue: 'U.S. Municipal Reference Entity Supplement' }),
    createToggleField({ key: 'seniorNonPreferredRefObligations', displayValue: 'Senior Non-Preferred Reference Obligations' }),
    createToggleField({ key: 'supp2014SovereignNoAssetPkgDelivery', displayValue: 'Sovereign No Asset Package Delivery Supplement' }),,
  {
    key: 'lastUpdatedBy',
    displayValue: 'Last Updated By',
    hideOnForm: true
  },
  {
    key: 'updatedOn',
    displayValue: 'Updated On',
    hideOnForm: true
  }
];

export const PHYSICAL_MATRIX_TOGGLE_COLUMNS = PHYSICAL_SETTLEMENT_MATRIX_COLUMNS.filter(col => col.type === 'toggle').map(col => col.key);
